<template>
  <div class="object-add_oad">

    <page-header>
      <h1> {{ mode === 'edit' ? 'Редактирование ' : 'Депонирование ' }}
        цифрового объекта авторского права</h1>
    </page-header>

    <div class="page-container_pcr">

      <app-inputs ref="inputs">

        <div class="block-wrap block-wrap_error" v-if="error.length">
          <div
            v-for="(e, i) in error"
            :key="`error-${i}`"
            class="block-wrap-error">
            {{ e }}
          </div>
        </div>
        <router-link
          class="help-link"
          :to="{ path: '/help/7'}"
          target="_blank">
          Подробнее о депонировании в разделе Помощь
        </router-link>
        <!--<button class="vivid-button" @click="initDraft">Загрузить черновик</button>-->
        <template v-if="mode !== 'edit'">
          <div
            class="block-wrap object-type-selector">
            <app-input
              :ref="`input-type`"
              widget="AppType"
              v-model="curTypeArr"
              :options="{ name: 'Type', required: true, title: 'Выберите тип объекта',
                placeholder: 'Выберите тип депонируемого объекта', showIcon: true }"/>
          </div>
        </template>
        <template v-else>
          <div v-if="objData && objData.TypeName" class="block-wrap ot-wrap">
            <div class="ot-icon">
              <img :src="`/static/grx/icons/objects/${objData.Type}.svg`">
            </div>
            <div class="ot-text">{{ objData.TypeName }}</div>
          </div>
        </template>
        <div v-if="curTypeArr[0] === ''" class="depo-msg_dmg">
          <div class="dmg_icon"></div>
          <div class="dmg_text">Начните процесс депонирования с выбора типа
            депонируемого объекта. Далее следуйте инструкциям платформы.</div>
        </div>
        <template v-if="curTypeArr[0] !== ''">
          <template v-for="(rField) in fieldRange">
            <template v-if="rField.fieldWidget === 'fieldset'">
              <div
                :key="'fieldset-' + componentKey + '-' + rField.fieldName"
                class="fieldset-block">
                <div class="fieldset-title">
                  {{ fieldsets[rField.fieldName].Title }}
                </div>
                <div v-show="fieldsets[rField.fieldName].Description" class="fieldset-description">
                  {{ fieldsets[rField.fieldName].Description }}
                </div>
                <!-- <div v-if="rField.fieldName === 'LicensesFieldset'">
                    <el-checkbox
                      v-if="fields['Licenses'] && fields['Licenses'].options.descriptionforced"
                      v-model="contractAgreement">
                    <div class="smart-contract-agreement">
                      {{ fields['Licenses'].options.descriptionforced }}
                    </div>
                  </el-checkbox>
                </div> -->
                <div v-for="(field, j) in fieldsets[rField.fieldName].fields"
                  :key="'fieldset-input-' + componentKey + '-' + rField.fieldName + '-' + j">
                  <!-- v-show="smartContractAgreement
                    || rField.fieldName !== 'LicensesFieldset'">-->
                  <app-input
                    class="block-wrap"
                    :ref="`input-${field}`"
                    v-model="values[field]"
                    :key="'app-input-' + componentKey + '-' + field"
                    :widget="fields[field].widget"
                    :options="fields[field].options"/>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                :key="'block-input-' + componentKey + '-' + rField.fieldName"
                class="block-wrap">
                <app-input
                  :ref="`input-${rField.fieldName}`"
                  v-model="values[rField.fieldName]"
                  :key="'app-input-' + componentKey + '-' + rField.fieldName"
                  :widget="fields[rField.fieldName].widget"
                  :options="fields[rField.fieldName].options"/>
              </div>
              </template>
          </template>
          <div v-if="showInputs" class="block-wrap buttons-wrap">
            <template v-if="mode === 'edit'">
              <button class="vivid-button" @click="updateObject">Сохранить изменения</button>
            </template>
            <template v-else>
              <button class="trans-button" @click="saveDraft">Сохранить как черновик</button>
              <button class="vivid-button" @click="submit">Отправить на депонирование</button>
            </template>
          </div>
        </template>

      </app-inputs>
    </div>
    <div
      v-show="showMarkupFrame"
      class="markup-frame">
      <div class="markup-header">
        Фрагментирование документа
      </div>
      <iframe
        class="markup-frame-conent"
        name="markupFrame"
        id="markupFrame"
        type="text/html"
        frameborder="0"></iframe>
      <div class="markup-footer">
        <button
          class="btn-close-markup"
          @click="hideMarkupFrame">
          Закрыть окно
        </button>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
/* eslint-disable default-case */
import J from 'jquery';
import axios from 'axios';
import Vue from 'vue';
import Misc from '../../mixins/Misc';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';

const MODE_DRAFT = 'draft';
const MODE_NORMAL = 'normal';
const MODE_EDIT = 'edit';

export default {

  mixins: [Misc],

  components: { PageHeader, PageFooter, AppInputs, AppInput },

  data() {
    return {
      curTypeArr: [],
      error: [],
      fields: {},
      values: {},
      fieldsets: {},
      fieldRange: [],
      valuesD: null,
      excludedFields: [
        'CreatorID', 'CreatedTime',
      ],
      mode: MODE_NORMAL,
      draft: null,
      componentKey: 0,
      objData: null,
      contractAgreement: false,
      showMarkupFrame: false,
    };
  },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  created() {
    this.draft = this.$store.getters['drafts/getDraft'];
    if (this.draft) {
      this.$store.commit('drafts/clearDraft');
      this.initDraft();
    }
    if (this.$route.params.objectId) {
      Vue.$loading.on();
      this.initEdit();
    }
  },

  computed: {
    showInputs() {
      return Object.keys(this.fields).length > 0;
    },

    userData() {
      return this.$store.getters['user/getUserData'];
    },
  },

  watch: {

    userData() {
      if (this.userData && !this.userData.Transient.Permissions.OBJECT_CREATE) {
        this.$alert('Чтобы депонировать объекты вам нужно быть сотрудником вуза-партнера. ' +
          'Вы можете зарегистрироваться на почту в домене вашего вуза или сменить почту в профиле.');
        this.$router.replace({ path: '/' });
      }
    },

    curTypeArr() {
      if (this.curTypeArr[0]) {
        this.componentKey += 1;
        axios.get(`objects/types/${this.curTypeArr[0]}?fieldsets=true`).then((res) => {
          if (this.mode === MODE_EDIT && this.objData) {
            this.objData.TypeName = res.data.Title;
          }
          this.contractAgreement = false;
          const type = res.data;
          const fields = type.Fields;
          this.fields = {};
          this.values = {};
          this.fieldsets = [];
          this.fieldRange = [];
          const woFieldset = 'woFieldset';
          this.fieldsets[woFieldset] = {};
          this.fieldsets[woFieldset].Name = woFieldset;
          this.fieldsets[woFieldset].fields = [];
          this.fieldsets[woFieldset].Title = '';
          this.fieldsets[woFieldset].Description = '';
          let curFieldset = '';
          fields.forEach((el) => {
            if (el.Extra || !el.Name || !el.Widget) { return; }
            if (el.Widget === 'fieldset') {
              if (!this.fieldsets[el.Name]) {
                this.fieldsets[el.Name] = {};
                this.fieldsets[el.Name].Name = el.Name;
                this.fieldsets[el.Name].fields = [];
                this.fieldsets[el.Name].Title = el.Title;
                this.fieldsets[el.Name].Description = el.Description;
                this.setFieldRange(el.Name, el.Widget);
              }
              return;
            }
            if (el.Fieldset && this.fieldsets[el.Fieldset]) curFieldset = el.Fieldset;
            else {
              curFieldset = woFieldset;
              this.setFieldRange(el.Name, el.Widget);
            }
            this.values[el.Name] = [];
            this.fields[el.Name] = {};

            const widgetName = el.Widget.charAt(0).toUpperCase() + el.Widget.slice(1);
            this.fields[el.Name].widget = `App${widgetName}`;

            if (this.fields[el.Name].widget === 'AppTextarea') {
              this.fields[el.Name].widget = 'AppText';
            } else if (this.fields[el.Name].widget === 'AppOrganization') {
              this.fields[el.Name].widget = 'AppObjectOrganization';
            }

            this.fields[el.Name].fieldset = curFieldset;
            this.fieldsets[curFieldset].fields.push(el.Name);

            this.fields[el.Name].common = el.Common;
            this.fields[el.Name].options = {};
            const options = this.fields[el.Name].options;
            options.componentKey = this.componentKey;
            this.fields[el.Name].options.name = el.Name;
            if (this.mode === MODE_EDIT || this.mode === MODE_DRAFT) {
              this.fields[el.Name].options.EditMode = true;
            }
            if (el.Title) { options.title = el.Title; }
            if (el.Description) { options.description = el.Description; }
            if (el.Examples) {
              options.example = el.Examples.join(', ');
            } else if (el.Example) {
              options.example = el.Example;
            }
            if (el.Required) { options.required = el.Required; }
            if (el.Regexp) { options.regexp = el.Regexp; }
            if (el.Multiple) { options.multiple = el.Multiple; }
            if (el.DefaultValue) { options.defaultvalue = el.DefaultValue; }
            if (el.DescriptionForced) { options.descriptionforced = el.DescriptionForced; }
            if (this.fields[el.Name].widget === 'AppObjectOrganization') { options.showAgreement = true; }

            if (el.WidgetOptions) {
              const wo = el.WidgetOptions;
              if (wo.MinLength) { options.minlength = wo.MinLength; }
              if (wo.MaxLength) { options.maxlength = wo.MaxLength; }
              if (wo.Options) { options.options = wo.Options; }
              if (wo.Relations) { options.relations = wo.Relations; }
              if (wo.OptionsDescriptions) { options.optionsDescriptions = wo.OptionsDescriptions; }
              if (wo.Vocabulary) { options.vocabulary = wo.Vocabulary; }
              if (wo.Min) { options.min = wo.Min; }
              if (wo.Max) { options.max = wo.Max; }
              if (wo.Rows) { options.rows = wo.Rows; }
              if (wo.Stake) { options.stake = wo.Stake; }
              if (wo.OnlyUsers) { options.OnlyUsers = wo.OnlyUsers; }
              if (wo.MultipleWithSeparator) {
                options.MultipleWithSeparator = wo.MultipleWithSeparator;
                options.multiple = false;
              }
              if (wo.Registries) { options.Registries = wo.Registries; }
              if (wo.Type === 'checkbox') {
                options.checkbox = true;
                options.multiple = false;
              }
            }
            // Add FilesPreview field after File field
            if (el.Name === 'Files') {
              const preview = 'FilesPreview';
              this.values[preview] = [];
              this.fields[preview] = Object.assign({}, this.fields[el.Name]);
              this.fields[preview].options = Object.assign({}, this.fields[el.Name].options);
              this.fields[preview].options.name = preview;
              this.fields[preview].options.required = false;
              this.fields[preview].options.title = 'Файлы предпросмотра';
              this.fieldsets[curFieldset].fields.push('FilesPreview');
              if (curFieldset === woFieldset) this.setFieldRange(preview, el.Widget);
              if (this.curTypeArr[0] === 'preprint'
                && this.mode !== MODE_EDIT) {
                options.showMarkupDialog = true;
                this.initMarkup();
              } else {
                options.showMarkupDialog = false;
              }
            }

            if (el.Name === 'CopyrightInformation') {
              const legal = 'FilesLegal';
              this.values[legal] = [];
              this.fields[legal] = {};
              this.fields[legal].common = true;
              this.fields[legal].fieldset = curFieldset;
              this.fields[legal].widget = 'AppFile';
              this.fields[legal].options = {};
              this.fields[legal].options.multiple = true;
              this.fields[legal].options.name = legal;
              this.fields[legal].options.required = false;
              this.fields[legal].options.title = 'Документы, подтверждающие сведения о правообладателях и правах';
              this.fieldsets[curFieldset].fields.push('FilesLegal');
              if (curFieldset === woFieldset) this.setFieldRange(legal, el.Widget);
            }
          });
          // Add Password Widget
          this.values.Password = [];
          this.fields.Password = { widget: 'AppPasswordSimple', fieldset: 'znone' };
          this.fields.Password.options = {
            title: 'Введите ваш пароль',
            name: 'Password',
            required: true,
          };
          curFieldset = woFieldset;
          if (!this.fieldsets[curFieldset]) {
            this.fieldsets[curFieldset] = {};
            this.fieldsets[curFieldset].Name = curFieldset;
            this.fieldsets[curFieldset].fields = [];
          }

          this.fieldsets[curFieldset].fields.push('Password');
          this.setFieldRange('Password', 'Password');

          if (this.mode === MODE_DRAFT) {
            this.$nextTick(() => {
              this.fetchDraft();
            });
          } else if (this.mode === MODE_EDIT) {
            this.$nextTick(() => { this.fetchObject(); });
          }
        });
      }
    },
  },

  methods: {

    hideMarkupFrame() {
      const iframe = document.getElementById('markupFrame');
      setTimeout(() => {
        iframe.src = 'about:blank';
      }, 100);
      this.showMarkupFrame = false;
    },

    initMarkup() {
      this.$nextTick(() => {
        this.$root.$on('sendToMarkup', (file) => {
          this.startFileMarkup(file);
        });
        window.addEventListener('message', (event) => {
          if (event.origin === 'https://reports.ipuniversity.ru' && event.data) {
            this.hideMarkupFrame();
            this.setMarkupData(event.data);
          }
        });
      });
    },

    startFileMarkup(file) {
      if (typeof this.$refs.inputs === 'undefined') return;
      const values = this.$refs.inputs.getValues();
      if (values.Title === '') {
        this.$message('Для фрагметирования файла необходимо ввести название препринта');
        return;
      }
      if (values.Authors.length === 0) {
        this.$message('Для фрагметирования файла необходимо ввести авторов препринта');
        return;
      }
      this.showMarkupFrame = true;
      const sendMarkupForm = document.createElement('FORM');
      sendMarkupForm.name = 'sendMarkupForm';
      sendMarkupForm.method = 'post';
      sendMarkupForm.action = 'https://reports.ipuniversity.ru/markup.php';
      sendMarkupForm.target = 'markupFrame';
      sendMarkupForm.setAttribute('display', 'none');

      let formValue = document.createElement('INPUT');
      formValue.type = 'text';
      formValue.name = 'title';
      formValue.value = encodeURI(values.Title);
      sendMarkupForm.appendChild(formValue);

      formValue = document.createElement('INPUT');
      formValue.type = 'text';
      formValue.name = 'uploadedFilename';
      formValue.value = file.uploadedFilename;
      sendMarkupForm.appendChild(formValue);

      formValue = document.createElement('INPUT');
      formValue.type = 'text';
      formValue.name = 'userFilename';
      formValue.value = encodeURI(file.userFilename);
      sendMarkupForm.appendChild(formValue);

      for (let i = 0; i < values.Authors.length; i += 1) {
        formValue = document.createElement('INPUT');
        formValue.type = 'text';
        formValue.name = 'authors[]';
        formValue.value = encodeURI(`${values.Authors[i].Surname} ${values.Authors[i].Name} ${values.Authors[i].Patronymic}`);
        sendMarkupForm.appendChild(formValue);
      }

      document.body.appendChild(sendMarkupForm);
      sendMarkupForm.submit();
      document.body.removeChild(sendMarkupForm);
    },

    setMarkupData(data) {
      if (typeof this.$refs.inputs === 'undefined') return;
      const markupData = JSON.parse(data);
      if (typeof markupData[0] === 'object'
        && markupData[0].uploadedFilename) {
        const values = this.$refs.inputs.getValues();
        if (values.Files) {
          for (let i = 0; i < values.Files.length; i += 1) {
            if (values.Files[i].uploadedFilename === markupData[0].uploadedFilename) {
              markupData.shift();
              values.Files[i].markup = markupData;
              break;
            }
          }
          this.$refs['input-Files'][0].setValue(values.Files);
        }
      } else {
        this.$message('Ошибка фрагментирования файла');
      }
    },

    setFieldRange(fieldName, fieldWidget) {
      this.fieldRange.push({
        fieldName,
        fieldWidget,
      });
    },

    saveDraft() {
      const values = this.$refs.inputs.getValues();
      delete values.Password;
      this.$prompt('Название черновика *', 'Сохранить как черновик', {
        inputValue: values.Title.length ? values.Title : '',
        inputPlaceholder: 'Укажите название...',
        confirmButtonText: 'Сохранить',
        cancelButtonText: 'Отменить',
        customClass: 'oad_prompt-dialog',
      }).then((promptData) => {
        if (!promptData.value.length) {
          this.$message.closeAll();
          this.$message.error('Черновик не может быть сохранен без названия');
          return;
        }
        const params = {
          title: promptData.value,
          values,
          action: 'create',
        };
        axios.post('drafts', params).then((r) => {
          this.$message.closeAll();
          this.$message.success(r.data);
        }).catch((err) => {
          if (err.response.status === 409) {
            this.$confirm(err.response.data, {
              confirmButtonText: 'Заменить',
              cancelButtonText: 'Отмена',
            }).then(() => {
              params.action = 'update';
              axios.post('drafts', params).then((r) => {
                this.$message.closeAll();
                this.$message.success(r.data);
              }).catch((err2) => {
                this.$message.closeAll();
                this.$message.success(err2.response.data);
              });
            }).catch(() => {});
          }
        });
      }).catch(() => {});
    },

    initDraft() {
      this.mode = MODE_DRAFT;
      this.curTypeArr = [this.draft.Type];
    },

    canEditObject(object) {
      if (object.Transient.Permissions.OBJECT_UPDATE === true) return true;
      return false;
    },

    initEdit() {
      this.mode = MODE_EDIT;
      const objectId = this.$route.params.objectId;
      if (objectId) {
        axios.get(`objects/${objectId}?loadRelated=true`).then((response) => {
          this.objData = response.data;
          if (!this.canEditObject(this.objData)) {
            Vue.$loading.off();
            this.$alert('Вы не можете редактировать данный объект');
            this.objData = null;
            this.$router.push({ path: '/403' });
          }
        }).catch(() => {
          Vue.$loading.off();
          this.$router.push({ path: '/404' });
        }).finally(() => {
          if (this.objData.Type) {
            this.curTypeArr = [this.objData.Type];
          }
        });
      }
    },

    fetchObject() {
      const f = this.fields;
      const d = this.objData;
      const files = { Files: [], FilesPreview: [], FilesLegal: [] };
      let fileType = '';
      for (let i = 0; i < d.Files.length; i += 1) {
        if (d.Files[i].Type === 'body') fileType = 'Files';
        else if (d.Files[i].Type === 'preview') fileType = 'FilesPreview';
        else if (d.Files[i].Type === 'legal') fileType = 'FilesLegal';
        files[fileType].push({
          description: d.Files[i].Description,
          hash: d.Files[i].Hash,
          hashProgress: 0,
          hashStopNow: true,
          isLoading: false,
          mime: d.Files[i].MIME,
          userFilename: d.Files[i].Name,
          size: d.Files[i].Size,
          uploadedFilename: d.Files[i].Name,
          fileId: d.Files[i].FileId,
          markup: d.Files[i].Markup ? JSON.parse(d.Files[i].Markup) : '',
        });
      }
      Object.keys(f).forEach((key) => {
        if (key === 'Contacts') {
          const contacts = [];
          for (let i = 0; i < d.Contacts.length; i += 1) {
            const ContactId = d.Contacts[i].UserId;
            contacts.push({
              UserId: ContactId,
              Surname: d.Transient.RelatedUsers[ContactId].Surname ? d.Transient.RelatedUsers[ContactId].Surname : '',
              Name: d.Transient.RelatedUsers[ContactId].Name ? d.Transient.RelatedUsers[ContactId].Name : '',
              Patronymic: d.Transient.RelatedUsers[ContactId].Patronymic ? d.Transient.RelatedUsers[ContactId].Patronymic : '',
            });
          }
          this.$refs[`input-${key}`][0].setValue(contacts);
        } else if (key === 'Files' || key === 'FilesPreview' || key === 'FilesLegal') {
          this.$refs[`input-${key}`][0].setValue(files[key]);
        } else if (d[key]) {
          this.$refs[`input-${key}`][0].setValue(d[key]);
        } else if (d.Metadata[key]) {
          this.$refs[`input-${key}`][0].setValue(d.Metadata[key]);
        }
      });
      Vue.$loading.off();
    },

    fetchDraft() {
      const f = this.fields;
      const d = this.draft;
      Object.keys(f).forEach((key) => {
        if (d[key]) {
          this.$refs[`input-${key}`][0].setValue(d[key]);
        }
      });
      this.mode = MODE_NORMAL;
    },

    submit() {
      /* this.$confirm('Начать процесс депонирования объекта интеллектуалной собственности?', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
      }).then(() => { */
      // this.$notify.success('Депонирование начато.');
      const inputs = this.$refs.inputs;

      if (!inputs.hasErrors()) {
        const vs = inputs.getValues();
        vs.Metadata = {};

        // Move common fields to Metadata
        Object.keys(vs).forEach((fieldName) => {
          const field = this.fields[fieldName];
          if (field && typeof field.common !== 'undefined' && !this.fields[fieldName].common) {
            vs.Metadata[fieldName] = vs[fieldName];
            delete vs[fieldName];
          }
        });
        // Process Files
        const rf = []; // RequestFiles
        for (let i = 0; i < vs.Files.length; i += 1) {
          if (vs.Files[i].userFilename) {
            rf.push({
              Name: vs.Files[i].userFilename,
              Description: vs.Files[i].description,
              Size: vs.Files[i].size,
              MIME: vs.Files[i].mime,
              Hash: vs.Files[i].hash,
              Type: 'body',
              uploadedFilename: vs.Files[i].uploadedFilename,
              Markup: vs.Files[i].markup ? JSON.stringify(vs.Files[i].markup) : '',
            });
          }
        }
        // Process FilesPreview
        if (vs.FilesPreview) {
          for (let i = 0; i < vs.FilesPreview.length; i += 1) {
            if (vs.FilesPreview[i].userFilename) {
              rf.push({
                Name: vs.FilesPreview[i].userFilename,
                Description: vs.FilesPreview[i].description,
                Size: vs.FilesPreview[i].size,
                MIME: vs.FilesPreview[i].mime,
                Hash: vs.FilesPreview[i].hash,
                Type: 'preview',
                uploadedFilename: vs.FilesPreview[i].uploadedFilename,
              });
            }
          }
          delete vs.FilesPreview;
        }
        // Process FilesLegal
        if (vs.FilesLegal) {
          for (let i = 0; i < vs.FilesLegal.length; i += 1) {
            if (vs.FilesLegal[i].userFilename) {
              rf.push({
                Name: vs.FilesLegal[i].userFilename,
                Description: vs.FilesLegal[i].description,
                Size: vs.FilesLegal[i].size,
                MIME: vs.FilesLegal[i].mime,
                Hash: vs.FilesLegal[i].hash,
                Type: 'legal',
                uploadedFilename: vs.FilesLegal[i].uploadedFilename,
              });
            }
          }
          delete vs.FilesLegal;
        }
        vs.Files = rf;
        if (!this.userData.PrivateKey) {
          this.$message('Для депонирования объекта обновите пароль в профиле пользователя');
        } else {
          vs.ObjectId = '';
          vs.EditorId = this.userData.UserId;
          vs.Edits = 0;
          axios.post('users/validatePassword', vs.Password).then(() => {
            const editorSignature =
              window.SignatureCreate(vs, this.userData.PrivateKey, vs.Password);
            vs.EditorSignature = editorSignature;
            Vue.$loading.on();
            axios.post('objects', JSON.stringify(vs)).then((r) => {
              this.$router.push({ path: '/user/objects', query: { taskId: r.data } });
              Vue.$loading.off();
            }).catch((error) => {
              this.$message('Заполните обязательные поля или исправьте ошибки');
              this.error = error.response.data;
              Vue.$loading.off();
              this.scrollTop();
            });
          }).catch((error) => {
            this.$message(error.response.data);
          });
        }
      } else {
        this.$message('Заполните обязательные поля или исправьте ошибки');
        let errorFlag = false;
        this.$refs.inputs.$children.forEach((el) => {
          if (errorFlag) return;
          el.getError().forEach((error) => {
            if (errorFlag) return;
            if (error !== '') {
              this.$nextTick(() => J('html, body').animate({
                scrollTop: J('.ait_message--error:visible:first').offset().top - 200 }, 1000),
              );
              errorFlag = true;
            }
          });
        });
      }
      //  }).catch(() => this.$notify.info('Депонирование отменено.'));
      //  }).catch(err => { console.error(err); })
    },

    updateObject() {
      const inputs = this.$refs.inputs;

      if (!inputs.hasErrors()) {
        const vs = inputs.getValues();
        vs.Metadata = {};

        // Move common fields to Metadata
        Object.keys(vs).forEach((fieldName) => {
          const field = this.fields[fieldName];
          if (field && typeof field.common !== 'undefined' && !this.fields[fieldName].common) {
            vs.Metadata[fieldName] = vs[fieldName];
            delete vs[fieldName];
          }
        });
        // Process Files
        const rf = []; // RequestFiles
        for (let i = 0; i < vs.Files.length; i += 1) {
          if (vs.Files[i].userFilename) {
            rf.push({
              Name: vs.Files[i].userFilename,
              Description: vs.Files[i].description,
              Size: vs.Files[i].size,
              MIME: vs.Files[i].mime,
              Hash: vs.Files[i].hash,
              Type: 'body',
              uploadedFilename: vs.Files[i].uploadedFilename,
              FileId: vs.Files[i].fileId,
              Markup: vs.Files[i].markup ? JSON.stringify(vs.Files[i].markup) : '',
            });
          }
        }
        // Process FilesPreview
        if (vs.FilesPreview) {
          for (let i = 0; i < vs.FilesPreview.length; i += 1) {
            if (vs.FilesPreview[i].userFilename) {
              rf.push({
                Name: vs.FilesPreview[i].userFilename,
                Description: vs.FilesPreview[i].description,
                Size: vs.FilesPreview[i].size,
                MIME: vs.FilesPreview[i].mime,
                Hash: vs.FilesPreview[i].hash,
                Type: 'preview',
                uploadedFilename: vs.FilesPreview[i].uploadedFilename,
                FileId: vs.FilesPreview[i].fileId,
              });
            }
          }
          delete vs.FilesPreview;
        }
        // Process FilesLegal
        if (vs.FilesLegal) {
          for (let i = 0; i < vs.FilesLegal.length; i += 1) {
            if (vs.FilesLegal[i].userFilename) {
              rf.push({
                Name: vs.FilesLegal[i].userFilename,
                Description: vs.FilesLegal[i].description,
                Size: vs.FilesLegal[i].size,
                MIME: vs.FilesLegal[i].mime,
                Hash: vs.FilesLegal[i].hash,
                Type: 'legal',
                uploadedFilename: vs.FilesLegal[i].uploadedFilename,
                FileId: vs.FilesLegal[i].fileId,
              });
            }
          }
          delete vs.FilesLegal;
        }
        vs.Files = rf;
        if (!this.userData.PrivateKey) {
          this.$message('Для редактирования объекта обновите пароль в профиле пользователя');
        } else {
          vs.ObjectId = this.objData.ObjectId;
          vs.EditorId = this.userData.UserId;
          vs.Type = this.objData.Type;
          vs.Edits = this.objData.Edits + 1;
          vs.CreatedTime = this.objData.CreatedTime;
          axios.post('users/validatePassword', vs.Password).then(() => {
            const editorSignature =
              window.SignatureCreate(vs, this.userData.PrivateKey, vs.Password);
            vs.EditorSignature = editorSignature;
            Vue.$loading.on();
            axios.put(`objects/${this.objData.ObjectId}`, JSON.stringify(vs)).then((r) => {
              this.$router.push({ path: '/user/objects', query: { taskId: r.data } });
            }).catch((error) => {
              this.$message('Заполните обязательные поля или исправьте ошибки');
              this.error = error.response.data;
              this.scrollTop();
            }).finally(() => {
              Vue.$loading.off();
            });
          }).catch((error) => {
            this.$message(error.response.data);
          });
        }
      } else {
        this.$message('Заполните обязательные поля или исправьте ошибки');
        let errorFlag = false;
        this.$refs.inputs.$children.forEach((el) => {
          if (errorFlag) return;
          el.getError().forEach((error) => {
            if (errorFlag) return;
            if (error !== '') {
              this.$nextTick(() => J('html, body').animate({
                scrollTop: J('.ait_message--error:visible:first').offset().top - 200 }, 1000),
              );
              errorFlag = true;
            }
          });
        });
      }
    },

  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";
.markup-frame {
  position: fixed;
  top: 30px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  margin: 0 auto 50px;
  z-index: 10;
  max-width: 1050px;
  height: 600px;
  background: #fff;
  border-radius: 12px;
  .markup-frame-conent {
    min-width: 100%;
    height: 508px;
  }
  .markup-header {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 18px;
    color:#d74b88;
  }
  .markup-footer {
    text-align: center;
    .btn-close-markup {
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      color:#000;
      &:hover {
        color: #d74b88;
        text-decoration: underline;
      }
    }
  }
}
.object-type-selector {
  margin-bottom: 35px;
}
.ot-wrap {
  padding-bottom: 17px;
  .ot-icon {
    display: inline-block;
    padding-right: 10px;
    img {
      height: 40px;
    }
  }
  .ot-text {
    font-size: 22px;
    color: #fff;
    display: inline-block;
    line-height: 40px;
    vertical-align: top;
  }
}
.object-add_oad {
  .page-container_pcr {
    max-width: 1100px;
  }
  .fieldset-block {
    max-width: 100%;
    padding: 25px;
    background: rgba(0, 0, 0, 0.2);
    margin: 15px auto;
    border-radius: 12px;
    .block-wrap {
      margin: 15px auto;
      padding: 25px;
    }
    .fieldset-input {
      padding-top: 50px;
    }
    .fieldset-title {
      font-size: 24px;
      color: #ededed;
    }
    .fieldset-description {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .block-wrap {
    max-width: 100%;
  }
  .license-separator {
    margin-top: 70px;
    margin-bottom: 70px;
  }
}
.oad_prompt-dialog {
  width: 900px !important;
  max-width: 900px !important;
  .el-message-box__message {
    color: $color-1 !important;
  }
  @media (max-width: 950px) {
    width: 600px !important;
    max-width: 600px !important;
  }
  @media (max-width: 650px) {
    width: auto !important;
    max-width: 100% !important;
  }
  .el-message-box__message {
    font-weight: 300 !important;
  }
  ::selection {
    background: rgba(000, 000, 000, .15) !important;
  }
  ::-moz-selection {
    background: rgba(000, 000, 000, .15) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ObjectAdd.vue